import React, { useContext } from 'react';
import get from 'lodash/get';

import { auth } from "../../config/firebase";

import StyledTable from '../tables/StyledTable';
import SummaryDataTableRow  from '../tables/SummaryDataTableRow';
import StyledGridItemWithHeader from '../shared/StyledGridItemWithHeader';

import { DataContext } from '../data/DataContext';
import { DataContextType } from '../data_types/interfaces';
import { formatCreationDate } from '../data/formatting';


const PlayerAccountData = ()=> {
    const context = useContext<DataContextType | undefined>(DataContext);
    const { playerData, deleteConfirmed } = context || {};

    if (deleteConfirmed) {
        return null;
    }

    const currentUser = auth.currentUser;
    var createdAt = null;

    // we are using the auth provider creation for the best possible result
    if (currentUser) {
      createdAt = get(currentUser, 'metadata.creationTime');
    }

    return (
        <StyledGridItemWithHeader header="Account Information" gridItemProps={{ xs: 12, sm: 12, md: 4 }}>
            <StyledTable headers={[]}>

                <SummaryDataTableRow
                    label="Player Name"
                    value={playerData.playerSettings.displayName}
                />

                <SummaryDataTableRow
                    label="Player Level"
                    value={playerData.playerStats.playerLevel}
                />

                <SummaryDataTableRow
                    label="Player Since"
                    value={
                      createdAt ?
                        formatCreationDate(createdAt)
                      :
                        'Unknown'
                    }
                />

            </StyledTable>
        </StyledGridItemWithHeader>
    );
};

export default PlayerAccountData;
